
import {
    KEY_TEXT_TAB_APPLY_FORM_AS,
    KEY_TEXT_TAB_APPLY_FORM_AS_PROXY,
    KEY_TEXT_TAB_APPLY_FORM_AS_TAX,
    KEY_TEXT_TAB_APPLY_FORM_CS,
    KEY_TEXT_TAB_APPLY_FORM_CS_1,
    KEY_TEXT_TAB_APPLY_FORM_HK,
    KEY_TEXT_TAB_APPLY_FORM_HK_L,
    KEY_TEXT_TAB_APPLY_FORM_HK_UL,
    KEY_TEXT_TAB_APPLY_FORM_OS,
    KEY_TEXT_TAB_APPLY_FORM_OS_BVI,
    KEY_TEXT_TAB_APPLY_FORM_OS_CAYMAN,
    KEY_TEXT_TAB_APPLY_FORM_OS_SEYCHELLES,
    KEY_TEXT_TAB_APPLY_FORM_SO,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BAR,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BE,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BNC,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_CSL,
    KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_TR,
    KEY_TEXT_TAB_APPLY_FORM_VO,
    KEY_TEXT_TAB_INDIVIDUAL,
    KEY_TEXT_TAB_REQUEST_SERVICE,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_PROXY,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_TAX,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_CREDITS,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_CS,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_L,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_UL,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_BVI,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_CAYMAN,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_SEYCHELLES,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_SERVICES,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_SO,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BAR,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BE,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BNC,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_CSL,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_TR,
    KEY_TEXT_TAB_SERVICE_MANAGEMENT_VO,
    KEY_TEXT_TAB_SUGGESTION_AND_ENQUIRY,
    KEY_TEXT_TAB_USER_MANAGEMENT,
    MODULE_SIDEBAR
} from "config/const/locale"
import i18n from "config/i18n"
import store from "config/store"


const { global: { lng } } = store.getState()

const t = i18n.getFixedT(lng, MODULE_SIDEBAR)


export const sidebarData = [
    {
        id: 1,
        to: '/users',
        linkClass: "nav-link",
        activeClass: "active",
        isAdminTab: true,
        key: KEY_TEXT_TAB_USER_MANAGEMENT,
        text: t(KEY_TEXT_TAB_USER_MANAGEMENT),
        iconBeforeText: "nav-icon fas fa-tachometer-alt",
        iconAfterText: "",
        badgeIcon: "",
        badgeText: "",
        subItems: []
    },
    {
        id: 2,
        to: '/admin/services',
        linkClass: "nav-link",
        activeClass: "active",
        isAdminTab: true,
        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT,
        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT),
        iconBeforeText: "nav-icon fas fa-th",
        iconAfterText: "right bi bi-caret-left-fill",
        badgeIcon: "",
        badgeText: "",
        subItems: [
            {
                id: 1,
                to: '/admin/services',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_SERVICES,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_SERVICES),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: []
            },
            {
                id: 11,
                to: '/admin/credits',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_CREDITS,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_CREDITS),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: []
            },
            {
                id: 2,
                to: '/admin/hk/l',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: '/admin/hk/l',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_L,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_L),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: "",
                    },
                    // {
                    //     id: 2,
                    //     to: '/admin/hk/ul',
                    //     linkClass: "nav-link",
                    //     activeClass: "active",
                    //     key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_UL,
                    //     text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_UL),
                    //     iconBeforeText: "far fa-circle nav-icon",
                    //     iconAfterText: "",
                    //     badgeIcon: "",
                    //     badgeText: ""
                    // }
                ]
            },
            {
                id: 3,
                to: '/admin/os/BVI',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: '/admin/os/BVI',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_BVI,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_BVI),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 2,
                        to: '/admin/os/cayman',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_CAYMAN,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_CAYMAN),
                        iconBeforeText: "",
                        iconAfterText: "",
                        // badgeIcon: "ml-3 align-middle badge badge-danger rounded-pill fs-6",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 3,
                        to: '/admin/os/seychelles',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_SEYCHELLES,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_SEYCHELLES),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    }
                ]
            },
            {
                id: 4,
                to: '/admin/so',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_SO,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_SO),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: ""
            },
            {
                id: 5,
                to: '/admin/vo',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_VO,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_VO),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: ""
            },
            {
                id: 8,
                to: '/admin/va/cs',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_CS,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_CS),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: '/admin/va/cs',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_CS,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_CS),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 2,
                        to: '/admin/va/cs1',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_CS_1,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_CS_1),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    }
                ]
            },
            {
                id: 9,
                to: '/admin/as/proxy',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: '/admin/as/proxy',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_PROXY,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_PROXY),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 2,
                        to: '/admin/as/tax',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_TAX,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_TAX),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    }
                ]
            },
            {
                id: 10,
                to: '/admin/va/be',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED,
                text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: '/admin/va/be',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BE,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BE),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 2,
                        to: '/admin/va/bnc',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BNC,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BNC),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 3,
                        to: '/admin/va/csl',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_CSL,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_CSL),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 4,
                        to: '/admin/va/tr',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_TR,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_TR),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 5,
                        to: '/admin/va/bar',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BAR,
                        text: t(KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BAR),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    }
                ]
            },
            // {
            //     id: 10,
            //     to: 'detailed',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "代理會計",
            //     text: "代理會計",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // },

        ]
    },
    {
        id: 3,
        to: '/individualAcc',
        linkClass: "nav-link",
        activeClass: "active",
        isAdminTab: false,
        key: KEY_TEXT_TAB_INDIVIDUAL,
        text: t(KEY_TEXT_TAB_INDIVIDUAL),
        iconBeforeText: "nav-icon fas fa-th",
        iconAfterText: "right",
        badgeIcon: "",
        badgeText: "",
        subItems: []
    },
    {
        id: 4,
        to: 'apply/hk/l',
        linkClass: "nav-link",
        activeClass: "active",
        isAdminTab: false,
        key: KEY_TEXT_TAB_REQUEST_SERVICE,
        text: t(KEY_TEXT_TAB_REQUEST_SERVICE),
        iconBeforeText: "nav-icon fas fa-th",
        iconAfterText: "right bi bi-caret-left-fill",
        badgeIcon: "",
        badgeText: "",
        subItems: [
            {
                id: 1,
                to: 'apply/hk/l',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_APPLY_FORM_HK,
                text: t(KEY_TEXT_TAB_APPLY_FORM_HK),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: 'apply/hk/l',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_HK_L,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_HK_L),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: "",
                    },
                    // {
                    //     id: 2,
                    //     to: 'apply/hk/ul',
                    //     linkClass: "nav-link",
                    //     activeClass: "active",
                    //     key: KEY_TEXT_TAB_APPLY_FORM_HK_UL,
                    //     text: t(KEY_TEXT_TAB_APPLY_FORM_HK_UL),
                    //     iconBeforeText: "far fa-circle nav-icon",
                    //     iconAfterText: "",
                    //     badgeIcon: "",
                    //     badgeText: ""
                    // }
                ]
            },
            {
                id: 2,
                to: 'apply/os/BVI',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_APPLY_FORM_OS,
                text: t(KEY_TEXT_TAB_APPLY_FORM_OS),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: 'apply/os/BVI',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_OS_BVI,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_OS_BVI),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 2,
                        to: 'apply/os/cayman',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_OS_CAYMAN,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_OS_CAYMAN),
                        iconBeforeText: "",
                        iconAfterText: "",
                        // badgeIcon: "ml-3 align-middle badge badge-danger rounded-pill fs-6",
                        // badgeText: "22"
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 3,
                        to: 'apply/os/seychelles',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_OS_SEYCHELLES,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_OS_SEYCHELLES),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    }
                ]
            },
            {
                id: 3,
                to: '/sug?type=serviced_office',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_APPLY_FORM_SO,
                text: t(KEY_TEXT_TAB_APPLY_FORM_SO),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: ""
            },
            {
                id: 4,
                to: 'apply/vo',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_APPLY_FORM_VO,
                text: t(KEY_TEXT_TAB_APPLY_FORM_VO),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: ""
            },
            {
                id: 8,
                to: '/apply/cs',
                // linkClass: "nav-link wa-btn-disable",
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_APPLY_FORM_CS,
                text: t(KEY_TEXT_TAB_APPLY_FORM_CS),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: '/apply/cs',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_CS,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_CS),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 2,
                        to: '/apply/cs1',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_CS_1,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_CS_1),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    }
                ]
            },
            {
                id: 9,
                to: '/sug?type=accounting_service',
                linkClass: "nav-link",
                activeClass: "active",
                key: KEY_TEXT_TAB_APPLY_FORM_AS,
                text: t(KEY_TEXT_TAB_APPLY_FORM_AS),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: '/sug?type=accounting_service',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_AS_PROXY,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_AS_PROXY),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    // {
                    //     id: 2,
                    //     to: '/sug?type=accounting_service',
                    //     linkClass: "nav-link",
                    //     activeClass: "active",
                    //     key: KEY_TEXT_TAB_APPLY_FORM_AS_TAX,
                    //     text: t(KEY_TEXT_TAB_APPLY_FORM_AS_TAX),
                    //     iconBeforeText: "far fa-circle nav-icon",
                    //     iconAfterText: "",
                    //     badgeIcon: "",
                    //     badgeText: ""
                    // }
                ]
            },
            {
                id: 10,
                to: '/apply/so',
                linkClass: "nav-link wa-btn-disable",
                activeClass: "active",
                key: KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED,
                text: t(KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED),
                iconBeforeText: "far fa-circle nav-icon",
                iconAfterText: "",
                badgeIcon: "",
                badgeText: "",
                subItems: [
                    {
                        id: 1,
                        to: '/sug?type=value_added_service',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BE,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BE),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 2,
                        to: '/apply/cp',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BNC,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BNC),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 3,
                        to: '/apply/excs',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_CSL,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_CSL),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 4,
                        to: '/apply/rb',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_TR,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_TR),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    },
                    {
                        id: 5,
                        to: '/sug?type=value_added_service',
                        linkClass: "nav-link",
                        activeClass: "active",
                        key: KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BAR,
                        text: t(KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BAR),
                        iconBeforeText: "far fa-circle nav-icon",
                        iconAfterText: "",
                        badgeIcon: "",
                        badgeText: ""
                    }
                ]
            },
            // {
            //     id: 8,
            //     to: 'formB',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "公司秘書",
            //     text: "公司秘書",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // },
            // {
            //     id: 9,
            //     to: 'formB',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "會計報税",
            //     text: "會計報税",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // },
            // {
            //     id: 10,
            //     to: 'formB',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "代理會計",
            //     text: "代理會計",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // },
            // {
            //     id: 11,
            //     to: 'formB',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "企業電郵",
            //     text: "企業電郵",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // },
            // {
            //     id: 12,
            //     to: 'formB',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "卡片印刷",
            //     text: "卡片印刷",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // },
            // {
            //     id: 13,
            //     to: 'formB',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "定製印章",
            //     text: "定製印章",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // },
            // {
            //     id: 14,
            //     to: 'formB',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "註冊商標",
            //     text: "註冊商標",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // },
            // {
            //     id: 15,
            //     to: 'formB',
            //     linkClass: "nav-link",
            //     activeClass: "active",
            //     key: "銀行户口",
            //     text: "銀行户口",
            //     iconBeforeText: "far fa-circle nav-icon",
            //     iconAfterText: "",
            //     badgeIcon: "",
            //     badgeText: ""
            // }
        ]
    },
    // {
    //     id: 5,
    //     to: '/wallet',
    //     linkClass: "nav-link",
    //     activeClass: "active",
    //     key: KEY_TEXT_TAB_WALLET,
    //     text: t(KEY_TEXT_TAB_WALLET),
    //     iconBeforeText: "nav-icon fas fa-th",
    //     iconAfterText: "right badge badge-danger",
    //     badgeIcon: "",
    //     badgeText: "",
    //     subItems: []
    // },
    // {
    //     id: 6,
    //     to: '/ins',
    //     linkClass: "nav-link",
    //     activeClass: "active",
    //     key: KEY_TEXT_TAB_MANUAL,
    //     text: t(KEY_TEXT_TAB_MANUAL),
    //     iconBeforeText: "nav-icon fas fa-th",
    //     iconAfterText: "right badge badge-danger",
    //     badgeIcon: "",
    //     badgeText: "",
    //     subItems: []
    // },
    {
        id: 7,
        to: '/sug?pure=true',
        linkClass: "nav-link",
        activeClass: "active",
        isAdminTab: false,
        key: KEY_TEXT_TAB_SUGGESTION_AND_ENQUIRY,
        text: t(KEY_TEXT_TAB_SUGGESTION_AND_ENQUIRY),
        iconBeforeText: "nav-icon fas fa-th",
        iconAfterText: "right badge badge-danger",
        badgeIcon: "New",
        badgeText: "",
        subItems: []
    },
]